/**
 * Translation definitions for i18n
 */

export type Language = 'tr' | 'en';

export const translations = {
  tr: {
    // App - Welcome
    welcome: {
      title: 'PriceLab',
      description: 'Birden fazla pazaryerinde ürün fiyatlandırmasını yönetin. Sütunları yapılandırın, kategori bazlı oranlar belirleyin ve karlılığı takip edin.',
    },

    // Stats
    stats: {
      products: 'Ürünler',
      inDatabase: 'Veritabanında',
      categories: 'Kategoriler',
      productCategories: 'Ürün kategorisi',
      skus: 'SKU\'lar',
      mappedToMarketplaces: 'Pazaryerlerine eşlenmiş',
      lastImport: 'Son İçe Aktarma',
      never: 'Henüz yok',
      dataRefresh: 'Veri güncelleme',
    },

    // Modules
    modules: {
      title: 'Modüller',
      marketplaces: 'Pazaryerleri',
      marketplacesDesc: 'Fiyatlandırma yönetimi',
      shipping: 'Kargo',
      shippingDesc: 'Kargo maliyet hesaplama',
      profitability: 'Karlılık',
      profitabilityDesc: 'Parent bazlı karlılık senaryosu',
      comingSoon: 'Yakında',
    },

    // Data Management
    dataManagement: {
      title: 'Veri Yönetimi',
      importProducts: 'Ürün İçe Aktar',
      fromGoogleSheets: 'Google Sheets\'ten',
      downloadBackup: 'Yedeği İndir',
      jsonFormat: 'JSON formatında',
      restore: 'Geri Yükle',
      restoring: 'Yükleniyor...',
      fromBackup: 'Yedekten geri yükle',
      lastBackup: 'Son yedekleme',
      noBackupYet: 'Henüz yedekleme yapılmadı',
      clearProducts: 'Ürünleri Sil',
      clearProductsDesc: 'Tüm ürünleri sil',
      resetDatabase: 'Veritabanını Sıfırla',
      resetDatabaseDesc: 'Tüm verileri sil',
      confirmClearProducts: 'Tüm ürünler silinecek. Bu işlem geri alınamaz. Devam etmek istiyor musunuz?',
      confirmResetDatabase: 'TÜM VERİLER silinecek (ürünler, ayarlar, pazaryerleri vb.). Bu işlem geri alınamaz. Devam etmek için "SİL" yazın:',
      clearing: 'Siliniyor...',
    },

    // Marketplace Grid
    marketplace: {
      title: 'Pazaryerleri',
      selectOrAdd: 'Pazaryeri seçin veya yeni ekleyin',
      countries: 'ülke',
      columns: 'sütun',
      inactive: 'Pasif',
      addNew: 'Yeni Pazaryeri Ekle',
      newMarketplace: 'Yeni Pazaryeri',
      name: 'İsim',
      shortCode: 'Kısa Kod',
      icon: 'İkon',
      color: 'Renk',
      create: 'Oluştur',
      note: 'Not: Şu an sadece Amazon yapılandırması aktif. Diğer pazaryerleri (Trendyol, Hepsiburada vb.) Amazon yapısı netleştikten sonra eklenecek.',
    },

    // Shipping Module
    shippingModule: {
      title: 'Kargo Modülü',
      description: 'Yurtiçi ve uluslararası gönderiler için kargo maliyet hesaplamaları.',
    },

    // Shipping Page
    shipping: {
      title: 'Kargo Tarifeleri',
      description: 'DESI bazlı kargo ücretlerini yönetin. Rotaları düzenleyin veya toplu yükleyin.',
      route: 'Rota',
      currency: 'Para Birimi',
      showAll: 'Tüm DESI',
      showLess: 'Daha Az',
      desiColumns: 'DESI sütunu',
      import: 'İçe Aktar',
      export: 'Dışa Aktar',
      saved: 'kaydedildi',
      errors: 'hata',
      tipTitle: 'İpucu',
      tipText: 'Hücrelere tıklayarak değerleri düzenleyebilirsiniz. CSV dosyası ile toplu yükleme yapabilirsiniz.',
    },

    // Common
    common: {
      save: 'Kaydet',
      cancel: 'İptal',
      delete: 'Sil',
      edit: 'Düzenle',
      close: 'Kapat',
      loading: 'Yükleniyor...',
      error: 'Hata',
      success: 'Başarılı',
      confirm: 'Onayla',
      back: 'Geri',
      next: 'İleri',
      yes: 'Evet',
      no: 'Hayır',
    },

    // Alerts
    alerts: {
      backupDownloadError: 'Yedekleme indirme hatası!',
      backupRestoreSuccess: 'Yedek başarıyla yüklendi! {count} kayıt geri yüklendi.',
      backupRestoreError: 'Yedek yükleme hatası! Dosya formatını kontrol edin.',
      deleteConfirm: '"{name}" pazaryerini silmek istediğinizden emin misiniz?',
      productsDeleted: 'Tüm ürünler silindi.',
      productsDeleteError: 'Ürünler silinirken hata oluştu.',
      databaseReset: 'Veritabanı sıfırlandı.',
      databaseResetError: 'Veritabanı sıfırlanırken hata oluştu.',
      wrongConfirmation: 'Yanlış onay kodu. İşlem iptal edildi.',
      productSaveError: 'Ürün kaydedilemedi',
    },

    // Settings Page
    settings: {
      title: 'Ayarlar',
      description: 'Uygulama ayarları ve veri yönetimi',
      general: 'Genel',
      products: 'Ürünler',
      exchangeRates: 'Döviz Kurları',
      language: 'Dil',
      selectLanguage: 'Uygulama dilini seçin',
      defaultCurrency: 'Varsayılan Para Birimi',
      calculationsInUsd: 'Tüm hesaplamalar USD üzerinden yapılır',
      searchProducts: 'Ürün ara...',
      product: 'ürün',
      noProducts: 'Henüz ürün yok. Veri Yönetimi sekmesinden ürün içe aktarın.',
      noSearchResults: 'Arama sonucu bulunamadı.',
      productName: 'Ürün Adı',
      category: 'Kategori',
      cost: 'Maliyet',
      weight: 'Ağırlık (kg)',
      dimensions: 'Boyutlar (cm)',
      actions: 'İşlem',
      moreProducts: '{count} ürün daha var. Arama yaparak daraltın.',
      importExport: 'İçe/Dışa Aktarma',
      databaseStatus: 'Veritabanı Durumu',
      dangerZone: 'Tehlikeli Bölge',
      currentRates: 'Güncel Döviz Kurları',
      ratesNote: 'Tüm hesaplamalar USD hub üzerinden yapılır',
      updateRates: 'Kurları Güncelle',
      lastUpdate: 'Son güncelleme: ',
      currency: 'Para Birimi',
      name: 'Ad',
      unit: 'birim',
      source: 'Kaynak',
      noRatesYet: 'Henüz döviz kuru yok. "Kurları Güncelle" butonuna tıklayın.',
      editProduct: 'Ürün Düzenle',
      costDollar: 'Maliyet ($)',
      packageDimensions: 'Paket Boyutları (cm)',
      width: 'Genişlik',
      height: 'Yükseklik',
      length: 'Uzunluk',
    },

    // Product Import Modal
    productImport: {
      title: 'Ürün Kataloğu İçe Aktar',
      uploadTitle: 'Excel veya CSV Dosyası Yükle',
      uploadDesc: '.xlsx, .xls veya .csv formatında dosya seçin',
      selectFile: 'Dosya Seç',
      uploading: 'Yükleniyor...',
      supportedColumns: 'Desteklenen Sütunlar',
      productName: 'Ürün adı',
      category: 'Kategori',
      costDollar: 'Maliyet ($)',
      desi: 'Desi',
      weightKg: 'Ağırlık (kg)',
      widthCm: 'Genişlik (cm)',
      heightCm: 'Yükseklik (cm)',
      lengthCm: 'Uzunluk (cm)',
      required: 'zorunlu',
      optional: 'opsiyonel',
      duplicatesFound: '{count} mevcut ürün bulundu',
      duplicatesDesc: 'Bu ürünler zaten veritabanında mevcut. Ne yapmak istersiniz?',
      update: 'Güncelle',
      updateDesc: 'Mevcut ürünleri yeni verilerle güncelle',
      skip: 'Atla',
      skipDesc: 'Mevcut ürünleri değiştirme, sadece yenileri ekle',
      andMore: '... ve {count} tane daha',
      productsToImport: '{count} ürün içe aktarılacak',
      importComplete: 'Import Tamamlandı!',
      importCompleteWithErrors: 'Import Tamamlandı (Hatalarla)',
      newProductsAdded: '{count} yeni ürün eklendi',
      productsUpdated: '{count} ürün güncellendi',
      productsSkipped: '{count} ürün atlandı',
      errors: 'Hatalar:',
      andMoreErrors: '... ve {count} hata daha',
      close: 'Kapat',
      cancel: 'İptal',
      back: 'Geri',
      continue: 'Devam',
      processing: 'İşleniyor...',
      import: 'İçe Aktar',
      invalidFormat: 'Geçersiz dosya formatı: {ext}\n\nDesteklenen formatlar: Excel (.xlsx, .xls) veya CSV (.csv)',
      fileEmpty: 'Dosya boş veya okunamadı',
      nameColumnNotFound: 'Ürün adı kolonu bulunamadı. Desteklenen kolon adları: name, product_name, product, ürün, ürün adı',
      categoryColumnNotFound: 'Kategori kolonu bulunamadı. Desteklenen kolon adları: category, kategori, cat',
      fileReadError: 'Dosya okunamadı',
      processingError: 'Dosya işlenirken hata oluştu',
      unknownError: 'Bilinmeyen hata',
    },
  },

  en: {
    // App - Welcome
    welcome: {
      title: 'PriceLab',
      description: 'Manage product pricing across multiple marketplaces. Configure columns, set category-based rates, and track profitability.',
    },

    // Stats
    stats: {
      products: 'Products',
      inDatabase: 'In Database',
      categories: 'Categories',
      productCategories: 'Product categories',
      skus: 'SKUs',
      mappedToMarketplaces: 'Mapped to marketplaces',
      lastImport: 'Last Import',
      never: 'Never',
      dataRefresh: 'Data refresh',
    },

    // Modules
    modules: {
      title: 'Modules',
      marketplaces: 'Marketplaces',
      marketplacesDesc: 'Pricing management',
      shipping: 'Shipping',
      shippingDesc: 'Shipping cost calculation',
      profitability: 'Profitability',
      profitabilityDesc: 'Parent-based profitability scenario',
      comingSoon: 'Coming Soon',
    },

    // Data Management
    dataManagement: {
      title: 'Data Management',
      importProducts: 'Import Products',
      fromGoogleSheets: 'From Google Sheets',
      downloadBackup: 'Download Backup',
      jsonFormat: 'JSON format',
      restore: 'Restore',
      restoring: 'Restoring...',
      fromBackup: 'Restore from backup',
      lastBackup: 'Last backup',
      noBackupYet: 'No backup yet',
      clearProducts: 'Clear Products',
      clearProductsDesc: 'Delete all products',
      resetDatabase: 'Reset Database',
      resetDatabaseDesc: 'Delete all data',
      confirmClearProducts: 'All products will be deleted. This cannot be undone. Continue?',
      confirmResetDatabase: 'ALL DATA will be deleted (products, settings, marketplaces, etc.). This cannot be undone. Type "DELETE" to confirm:',
      clearing: 'Clearing...',
    },

    // Marketplace Grid
    marketplace: {
      title: 'Marketplaces',
      selectOrAdd: 'Select a marketplace or add new',
      countries: 'countries',
      columns: 'columns',
      inactive: 'Inactive',
      addNew: 'Add New Marketplace',
      newMarketplace: 'New Marketplace',
      name: 'Name',
      shortCode: 'Short Code',
      icon: 'Icon',
      color: 'Color',
      create: 'Create',
      note: 'Note: Only Amazon configuration is active. Other marketplaces (Trendyol, Hepsiburada, etc.) will be added after Amazon structure is finalized.',
    },

    // Shipping Module
    shippingModule: {
      title: 'Shipping Module',
      description: 'Shipping cost calculations for domestic and international shipments.',
    },

    // Shipping Page
    shipping: {
      title: 'Shipping Rates',
      description: 'Manage DESI-based shipping costs. Edit routes or bulk upload.',
      route: 'Route',
      currency: 'Currency',
      showAll: 'All DESI',
      showLess: 'Less',
      desiColumns: 'DESI columns',
      import: 'Import',
      export: 'Export',
      saved: 'saved',
      errors: 'errors',
      tipTitle: 'Tip',
      tipText: 'Click on cells to edit values. You can bulk upload via CSV file.',
    },

    // Common
    common: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      close: 'Close',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      confirm: 'Confirm',
      back: 'Back',
      next: 'Next',
      yes: 'Yes',
      no: 'No',
    },

    // Alerts
    alerts: {
      backupDownloadError: 'Backup download failed!',
      backupRestoreSuccess: 'Backup restored successfully! {count} records restored.',
      backupRestoreError: 'Backup restore failed! Check file format.',
      deleteConfirm: 'Are you sure you want to delete "{name}" marketplace?',
      productsDeleted: 'All products deleted.',
      productsDeleteError: 'Failed to delete products.',
      databaseReset: 'Database reset complete.',
      databaseResetError: 'Database reset failed.',
      wrongConfirmation: 'Wrong confirmation. Operation cancelled.',
      productSaveError: 'Failed to save product',
    },

    // Settings Page
    settings: {
      title: 'Settings',
      description: 'Application settings and data management',
      general: 'General',
      products: 'Products',
      exchangeRates: 'Exchange Rates',
      language: 'Language',
      selectLanguage: 'Select application language',
      defaultCurrency: 'Default Currency',
      calculationsInUsd: 'All calculations are done in USD',
      searchProducts: 'Search products...',
      product: 'products',
      noProducts: 'No products yet. Import products from Data Management tab.',
      noSearchResults: 'No search results found.',
      productName: 'Product Name',
      category: 'Category',
      cost: 'Cost',
      weight: 'Weight (kg)',
      dimensions: 'Dimensions (cm)',
      actions: 'Actions',
      moreProducts: '{count} more products. Use search to narrow down.',
      importExport: 'Import/Export',
      databaseStatus: 'Database Status',
      dangerZone: 'Danger Zone',
      currentRates: 'Current Exchange Rates',
      ratesNote: 'All calculations are done through USD hub',
      updateRates: 'Update Rates',
      lastUpdate: 'Last update: ',
      currency: 'Currency',
      name: 'Name',
      unit: 'unit',
      source: 'Source',
      noRatesYet: 'No exchange rates yet. Click "Update Rates" button.',
      editProduct: 'Edit Product',
      costDollar: 'Cost ($)',
      packageDimensions: 'Package Dimensions (cm)',
      width: 'Width',
      height: 'Height',
      length: 'Length',
    },

    // Product Import Modal
    productImport: {
      title: 'Import Product Catalog',
      uploadTitle: 'Upload Excel or CSV File',
      uploadDesc: 'Select file in .xlsx, .xls, or .csv format',
      selectFile: 'Select File',
      uploading: 'Uploading...',
      supportedColumns: 'Supported Columns',
      productName: 'Product name',
      category: 'Category',
      costDollar: 'Cost ($)',
      desi: 'Desi',
      weightKg: 'Weight (kg)',
      widthCm: 'Width (cm)',
      heightCm: 'Height (cm)',
      lengthCm: 'Length (cm)',
      required: 'required',
      optional: 'optional',
      duplicatesFound: '{count} existing products found',
      duplicatesDesc: 'These products already exist in the database. What would you like to do?',
      update: 'Update',
      updateDesc: 'Update existing products with new data',
      skip: 'Skip',
      skipDesc: 'Keep existing products, only add new ones',
      andMore: '... and {count} more',
      productsToImport: '{count} products will be imported',
      importComplete: 'Import Complete!',
      importCompleteWithErrors: 'Import Complete (With Errors)',
      newProductsAdded: '{count} new products added',
      productsUpdated: '{count} products updated',
      productsSkipped: '{count} products skipped',
      errors: 'Errors:',
      andMoreErrors: '... and {count} more errors',
      close: 'Close',
      cancel: 'Cancel',
      back: 'Back',
      continue: 'Continue',
      processing: 'Processing...',
      import: 'Import',
      invalidFormat: 'Invalid file format: {ext}\n\nSupported formats: Excel (.xlsx, .xls) or CSV (.csv)',
      fileEmpty: 'File is empty or cannot be read',
      nameColumnNotFound: 'Product name column not found. Supported column names: name, product_name, product',
      categoryColumnNotFound: 'Category column not found. Supported column names: category, cat',
      fileReadError: 'Cannot read file',
      processingError: 'Error processing file',
      unknownError: 'Unknown error',
    },
  },
};

// Use interface to allow both tr and en to match
export type TranslationKeys = typeof translations.tr | typeof translations.en;
